// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2juzT","emails":"CreateEditClinics_emails__xxkx3","emailTagLabel":"CreateEditClinics_emailTagLabel__1c6r4"};